// hooks/usePWAJumpIframe.ts
import { ref, onMounted } from 'vue'
import { isInPWA } from '@/env' // 确保路径正确

export function usePWAJumpIframe() {
  const iframeUrl = ref<any>(null)
  const isPWA = ref<boolean>(false)
  const shouldShowIframe = ref<boolean>(false)
  async function checkPWAAndPreventionJump() {
    isPWA.value = isInPWA
    if (!isPWA.value) {
      console.log('不在 PWA 环境中')
      return
    }

    console.log('检测是否在 pwa 应用打开的项目``111111111```````')
    console.log('当前全链接:', window.location.href)
    const hostname = window.location.hostname
    const currentUrl = new URL(window.location.href)
    const params = new URLSearchParams(currentUrl.search)
    const newUrlParams = Array.from(params.entries())
      .filter(([key]) => key !== 'preventionJump' && key !== 'currentDomain')
      .map(([key, value]) => `${key}=${value}`)
      .join('&')

    if (currentUrl.searchParams.get('preventionJump') !== 'true') {
      console.log('preventionJump 参数不是 true')
      return
    }

    const currentDomain = currentUrl.searchParams.get('currentDomain')
    const postData = async (url = '', data: Record<string, unknown>) => {
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Access-Control-Allow-Origin': '*', // 注意跨域问题，可能需要调整
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return await response.json()
      } catch (error) {
        console.error('Error during fetch:', error)
        return null
      }
    }

    const result = await postData(`https://${currentDomain}/hdc-api/domain`, {
      domain: hostname,
    })

    if (result && Array.isArray(result) && result.length > 0) {
      const randomDomain = result[0]
      const getRandomElement = (array: string[]) => {
        return array[Math.floor(Math.random() * array.length)]
      }
      const jumpDomain = getRandomElement(randomDomain.lunchDomain.split(','))

      console.log('检测是否在 pwa 应用打开的项目``22222222```````', jumpDomain)
      const newUrl = `https://${jumpDomain}/home?${newUrlParams}`
      console.log(
        '检测是否在 pwa 应用打开的项目````````33333333333````````',
        newUrl,
      )
      if (newUrl) {
        iframeUrl.value = newUrl
        shouldShowIframe.value = true
      }
    }
  }

  onMounted(checkPWAAndPreventionJump)

  return {
    isPWA,
    iframeUrl,
    shouldShowIframe,
  }
}
